import { Injector } from '@angular/core';

export class StaticInjector {
  static instance?: Injector
}
